import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AvailableInputTypeV0 } from '../../../rdsap-api/model/availableInputTypeV0';

// Define the custom entity collection service
// This service is used to provide access to the CustomInputTypes data service
@Injectable({ providedIn: 'root' })
export class InputTypesService extends EntityCollectionServiceBase<AvailableInputTypeV0> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('CustomInputTypes', serviceElementsFactory);
  }
}
